<template>
    <header>
        <nav
            class="navbar navbar-expand-sm navbar-dark bg-olf-dark-slate-grey"
            :class="{ 'fixed-top': !$breakpoint.mdAndDown, 'px-0' : $breakpoint.lgAndDown }"
        >
            <div class="container-fluid">
                <div class="navbar-brand">
                    <router-link to="/" @click.native="goToDashboard()">
                        <img src="/assets/rebrandLogo2.png" alt="Online fuels logo" style="width:200px; height:50px;" />
                    </router-link>
                </div>

                <button v-if="isLoggedIn" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbarMenu">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div v-if="isLoggedIn" class="collapse navbar-collapse" id="collapsingNavbarMenu">
                    <ul v-if="userLoggedIn.termsAccepted && !$breakpoint.mdAndDown" class="navbar-nav mr-auto">
                        <li class="nav-item" v-for="(item, index) in menu" :key="index">

                            <router-link :to="item.link" class="nav-link" :class="{active: currentRouteTitle === item.title}">

                                <strong><i class="fas" :class="[item.icon, {'notification': notificationCounter(item.id)}]"></i>{{item.title}}</strong>
                            </router-link>
                        </li>
                    </ul>
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" role="button" id="userMenuDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-user-circle"></i>&nbsp;<strong>{{userLoggedIn.name}}</strong>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userMenuDropdown">
                                <a href="#" class="dropdown-item" v-for="(item, index) in accountMenu" :key="index"
                                    @click="selectAccountMenuItem(index)">
                                    <i class="fas" :class="item.icon"></i>{{item.title}}
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <nav v-if="$breakpoint.mdAndDown" class="navbar navbar-dark navbar-expand-sm bg-olf-dark-slate-grey fixed-bottom justify-content-center px-0">
            <ul v-if="userLoggedIn.termsAccepted" class="navbar-nav flex-row">
                <li class="nav-item" v-for="(item, index) in menu" :key="index">
                    <router-link :to="item.link"
                        class="nav-link"
                        :class="{
                            active: currentRouteTitle === item.title
                        }"
                    >
                        <strong>
                            <i class="fas" :class="[item.icon, {'notification': notificationCounter(item.id)}]"></i>
                            <span v-if="!$breakpoint.xsOnly">{{item.title}}</span>
                        </strong>
                    </router-link>
                </li>
            </ul>
        </nav>
    </header>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import breakpoint from '@/mixins/index';
const { detect } = require('detect-browser');
const moment = require('moment');

import { eNavbarTitles } from "@/util/enums/navbar";

export default {
    mixins: [breakpoint],
    data() {
        return {
            socket : io(),
            browser: detect(),
            isLoggedIn: false,
            secondsLeft: 0,
            timeout: '',
            accountMenuList: [
                {title: 'My Account', icon: 'fa-cog', link: '/MyAccount'},
                // {title: 'Tools', icon: 'fa-wrench'},
                // {title: 'Help', icon: 'fa-info-circle'},
                {title: 'Sign Out', icon: 'fa-power-off'}
            ]
        }
    },
    methods: {
        ...mapMutations('orders',['UPDATE_MARKET_WINDOW_ID']),
        ...mapActions('graphs', ['populateMarketChangeSeriesData']),
        ...mapActions('login', ['updateShowConfirmationLogout', 'getAccountMetadata']),
        ...mapActions('offers', ['getLiveOffers', 'getDeliveryLocations']),
        ...mapActions('sellerOffers', ['getOffersTimeAvailability', 'getAllOffersForUser']),
        ...mapActions('negotiation',['updateFuelPrices', 'getNegotiations', 'selectNegotiation', 'selectFuelGroup']),
        ...mapActions('notifications', ['popNotification', 'getNotifications']),
        ...mapActions('livePrices', ['updateLivePrices', 'updateMarketChange','openModal', 'updateSellerPrices', 'emptySellerPrices',
            'setSecondsLeft', 'updateMarketWindowTimes', 'setDailyPricesOpenedStatus']),
        ...mapMutations('login',['LOGOUT_USER']),
        ...mapActions('buyerOpen',['getIsPlatformClosed']),
        ...mapActions('terminals',['getTerminals']),
        ...mapActions("fuelsType",["getFuelsList"]),
        ...mapActions('offers', ['getLiveContractsList']),
        ...mapActions('accounts', ['getRelationships', 'getUserRoles', "getAccountDetails"]),
        ...mapActions('metadata', ['getNetworks']),
        ...mapActions('orders',['allowUpdateOrderList']),
        marketTimerRefreshAndRetry() {
          // reset the value being shown to the user
          this.$store.commit('livePrices/SET_MARKET_REFRESH_TIMER', 5000);
          // start the count down again
          this.secondsLeft = setInterval(this.refreshingPrices, 1000);
          this.timeout = setTimeout(this.refreshingPrices, 5000);
        },
        refreshingPrices: async function(){
            await this.setSecondsLeft(); // Update seconds left

            /* If timer has reached 0, then refresh all data */
            if (this.refreshSecondsLeft === 0){
                clearInterval(this.secondsLeft);
                clearTimeout(this.timeout);

                /* Fetch the new market window data */
                try {
                    let shouldUserStayLoggedIn = await this.axios.get("/api/userStatus");
                    if (shouldUserStayLoggedIn.data.success === false || shouldUserStayLoggedIn.data.payload.enabled === true) {
                        const currentMarketWindowResponse = await this.axios.get("/api/getCurrentMarketWindow");
                        const marketWindowData = currentMarketWindowResponse.data.payload;

                        if (marketWindowData != null && currentMarketWindowResponse.data.success) {
                            // Restart the countdown
                            this.secondsLeft = setInterval(this.refreshingPrices, 1000);

                            /* Fetch all generic data and update market window data */
                            this.$store.dispatch("login/getAccountMetadata");
                            this.getUserRoles();
                            this.getAccountDetails();
                            this.getIsPlatformClosed();
                            this.getRelationships();
                            this.getLiveContractsList();
                            await this.getAccountMetadata();
                            this.updateMarketWindowTimes(marketWindowData);
                            this.updateLivePrices(marketWindowData);
                            this.UPDATE_MARKET_WINDOW_ID(marketWindowData._id);
                            this.updateFuelPrices(marketWindowData.fuels);
                            this.updateMarketChange(marketWindowData.marketChange);
                            this.getNegotiations({ status: 'All' });
                            this.allowUpdateOrderList(true);

                            if (this.browser.name !== 'edge' || this.browser.name !== 'ie')
                                this.populateMarketChangeSeriesData();

                            //Redirect if user is no longer authorised to access current page
                            this.redirectIfAccessToCurrentPathIsDisabled();

                            /* Fetch data relevant to a buyer */
                            if (this.userLoggedIn.category == 'buyer'){
                                this.getLiveOffers()

                                if (Object.keys(this.negotiationSelected).length > 0){
                                    this.selectNegotiation(this.negotiationSelected._id)
                                }
                            }
                            /* Fetch data relevant to a seller */
                            if (this.userLoggedIn.category == "seller") {
                                this.getNetworks();
                                this.getTerminals();
                                this.checkSellerSettlement();
                                this.getOffersTimeAvailability()
                                this.getAllOffersForUser()
                            }
                        } else {
                          this.marketTimerRefreshAndRetry();
                        }
                    } else if(shouldUserStayLoggedIn.data.payload.enabled === false){
                        this.LogDeactivatedUserOut()
                    }
                } catch (ex){
                    this.marketTimerRefreshAndRetry();
                }
            }
        },
        getNavBarItems: function(accountType){
            let menu = [];            
            if (accountType === 'buyer') {
                menu = [
                    { title: eNavbarTitles.dashboard, icon: 'fa-th-large', link: '/buyerDashboard' },
                    { title: eNavbarTitles.allPrices, icon: 'fa-chart-line', link: '/AllPrices/ex-rack' },
                    { title: eNavbarTitles.negotiations, icon: 'fa-handshake', link: '/NegotiationsBuyer', id: 'NEGOTIATION' },
                    { title: eNavbarTitles.olfChat, icon: 'fa-comments', link: '/Chat', id: 'MESSAGE' },
                    { title: eNavbarTitles.orderHistory, icon: 'fa-calendar-check', link: '/OrderHistory/all', id: 'ORDER' },
                ]
                if(this.getHasExistingContracts){
                    const menuItem = { title: eNavbarTitles.contracts, icon: 'fa-file-signature', link: '/ExistingContracts', id: 'CONTRACT' };
                    menu.splice(3, 0, menuItem);
                }
            } else if (accountType === 'seller') {
                menu = [
                    { title: eNavbarTitles.dashboard, icon: 'fa-th-large', link: '/sellerDashboard' },
                    { title: eNavbarTitles.manageOffers, icon: 'fa-chart-line', link: '/manageOffers/spot' },
                    { title: eNavbarTitles.negotiations, icon: 'fa-handshake', link: '/NegotiationsSeller', id: 'NEGOTIATION' },
                    { title: eNavbarTitles.olfChat, icon: 'fa-comments', link: '/Chat', id: 'MESSAGE' },
                    { title: eNavbarTitles.manageCustomers, icon: 'fas fa-users', link: '/MyCustomers' },
                    { title: eNavbarTitles.orderHistory, icon: 'fa-calendar-check', link: '/OrderHistory/all', id: 'ORDER' },
                ]

                //Add any conditional navigation items
                if (this.getIsOrderCaptureEnabledForUser) {
                    const menuItem =  {title: eNavbarTitles.orderCapture, icon: 'fa-file-invoice-dollar', link: '/OrderCapture/spot', id: 'ORDER_CAPTURE' };
                    menu.splice(2, 0, menuItem);
                }
                if (this.isPricingEngineEnabled) {
                    const menuItem =  {title: eNavbarTitles.pricingEngine, icon: 'fa-solid fa-calculator', link: '/PricingEngine', id: 'PRICING_ENGINE' };
                    menu.splice(1, 0, menuItem);
                }
                
            }
            return menu;
        },
        LogDeactivatedUserOut: function(){
            this.setDailyPricesOpenedStatus(false)
            this.LOGOUT_USER()
            this.$router.push("/logoutSuccessful")
            this.$cookies.remove("user")
            location.reload(true)
        },
        selectAccountMenuItem: function(index) {
            event.preventDefault()

            if (index == 0){
                this.$router.push({name: 'MyAccount'})
            }
            else if (index == (this.accountMenu.length - 1)){
                this.logout()
            }
        },
        logout() {
            this.updateShowConfirmationLogout(true)
        },
        goToDashboard: function(){
            if(this.userLoggedIn.category == 'buyer'){
                this.$router.push("/buyerDashboard");
            }else if(this.userLoggedIn.category == 'seller'){
                this.$router.push("/sellerDashboard");
            }
        },
        redirectIfAccessToCurrentPathIsDisabled(){
            const featureRequired = this.$route.meta.featureRequired;
            if (featureRequired && !this.getAllAccountFeatures.includes(featureRequired)) {
                this.goToDashboard();
            }
        },
        notificationCounter: function(id){
            let counter = 0; // counter to be returned by the function
            for(let i = 0; this.notificationList.length > i; i++){
                if(this.notificationList[i].type_id === id && this.notificationList[i].viewed === null){
                    if(this.notificationList[i].type_id === 'NEGOTIATION' && this.notificationList[i].viewed === null && moment(this.notificationList[i].created).isBefore(moment(),'day')){
                        // do not count negotiation notifications if created before today
                    }else{
                        counter++; // increment counter by 1 if notification has not been viewed & is relevent to the menu item found on navbar
                    }
                }
            }
            return Number(counter);
        },
        checkSellerSettlement: async function(){
            const isPricingEngineEnabled = this.$store.getters["login/isPricingEngineEnabled"];
            this.$store.dispatch("livePrices/setSettlementPricesButtonText", isPricingEngineEnabled);

            if (isPricingEngineEnabled){ // This seller has pricing engine enabled
                // Fetch their global rules
                await this.$store.dispatch("rules/getGlobalRules");
                // we need to keep this in as the offer modal needs the rules populated before it opens up, else cost addition rules are empty
                this.$store.dispatch("rules/getCostAdditionRules");
                const dailySettlement = this.$store.getters["rules/globalRulesGetter"].dailySettlementRules;
                
                // Check whether daily settlement rules have expired or not
                if (dailySettlement.find(r => r.hasDailySettlementExpired == null || r.hasDailySettlementExpired == true)){
                    this.clearSellerSettlement();
                } else {
                    // Update the store with settlement and live prices
                    this.$store.dispatch("livePrices/getSellerProductPrices", { dailySettlement });
                }
            } else { // This seller does not have pricing engine enabled
                try { // Now let's check whether seller has input their settlement prices for today
                    const settlementsResponse = await this.axios.get('/api/getSettlements', {params: { seller_id: this.userLoggedIn.id }});
                    this.updateSellerPrices(settlementsResponse.data.payload);
                } catch (ex) {
                    if (ex.response.data && ex.response.data.body && ex.response.data.body.errorId === 'NO_DAILY_SETTLEMENTS') // No settlement prices found
                        this.clearSellerSettlement();
                }
            }
        },
        clearSellerSettlement: function(){
            this.emptySellerPrices();
            
            // Let's check whether we need to open the settlement popup for this seller now
            if((!this.dailyPricesOpenedOnce || !moment(this.dailyPricesLastOpenedTime).isSame(moment(), 'day')) // We have not opened the popup for this seller today
                && this.userLoggedIn.termsAccepted) // User has accepted T&Cs
            {
                this.openModal();
            }
        }
    },
    mounted: async function() {
        let userId = this.userLoggedIn.userId;
        if (userId) {
            console.log(`Socket Connected for user ${userId}`);
            this.socket.emit('users_add_session', { userId })
        }

        //Listen for the 'user_notification' message to come back from the server, so we can react to events
        /*
            Current Events...
            service_send_negotiation_alert
            service_send_counteroffer_alert
            service_send_message_alert
        */
        this.socket.on('user_notification', (data) => {
            //When we get a notification from the server, display the message
            const payload = {
                shown: true,
                data: data
            }
            setTimeout(() => {
                this.getNotifications()
                this.popNotification(payload)
            }, 1000)
        });

        //If we get reconnected to the notification service for whatever reason, this will force us to re-advertise
        this.socket.on('reconnect', function() {
            console.log(`Socket Reconnected for user ${userId}`);
            this.emit('users_add_session', { userId });
        });
    },
    created: async function (){
        clearInterval(this.secondsLeft);
        clearTimeout(this.timeout);
        this.isLoggedIn = true;

        const [fuelList, terminalList, networkList, marketWindowData, accountMetadata, userRoles, accountDetails] = await Promise.all([
          this.getFuelsList(),
          this.getTerminals(),
          this.getNetworks(),
          (await this.axios.get("/api/getCurrentMarketWindow")).data.payload,
          this.$store.dispatch("login/getAccountMetadata"),
          this.getUserRoles(),
          this.getAccountDetails(),
        ]);

        /* Update market window data */
        if (marketWindowData){
            this.updateMarketWindowTimes(marketWindowData);
            this.updateLivePrices(marketWindowData);
            this.UPDATE_MARKET_WINDOW_ID(marketWindowData._id);
            this.updateFuelPrices(marketWindowData.fuels);
            this.updateMarketChange(marketWindowData.marketChange);
            this.secondsLeft = setInterval(this.refreshingPrices, 1000); // Start the countdown
        }
        
        this.getIsPlatformClosed();
        this.getNotifications();
        this.getNegotiations({ status: 'All' });
        this.getDeliveryLocations();
        this.allowUpdateOrderList(true);

        if (this.browser.name !== 'edge' || this.browser.name !== 'ie')
            this.populateMarketChangeSeriesData();

        /* Fetch data relevant to a Buyer OR Seller */
        if (this.userLoggedIn.category == 'buyer') {
            this.getLiveOffers();
            await this.getLiveContractsList();
        }
        if (this.userLoggedIn.category == "seller") {
            this.checkSellerSettlement();
            this.getOffersTimeAvailability();
            this.getAllOffersForUser();
            
            if (this.$store.getters["login/isPricingEngineEnabled"])
                this.$store.dispatch("metadata/getStaMatrix");
        }
    },
    computed: {
        ...mapState('livePrices', ['dailyPricesOpenedOnce', 'dailyPricesLastOpenedTime', 'refreshSecondsLeft']),
        ...mapState('login',['userLoggedIn', 'showConfirmationLogout']),
        ...mapState('negotiation', ['negotiationSelected', 'fuelGroupSelected']),
        ...mapState('notifications', ['notificationList']),
        ...mapGetters('offers', ['getHasExistingContracts']),
        ...mapGetters('login', ['getAllAccountFeatures','getIsOrderCaptureEnabledForUser', 'isPricingEngineEnabled']),

        accountMenu: {
            get: function(){
                if (this.userLoggedIn.termsAccepted){
                    return [...this.accountMenuList]
                }
                else {
                    return [this.accountMenuList[this.accountMenuList.length - 1]]
                }
            }
        },
        menu: function() {
            const accountType = this.userLoggedIn.category;
            return this.getNavBarItems(accountType);
        },
        openConfirmationLogout: function(){
            if (this.showConfirmationLogout){
                let element = this.$root.$refs.confirmationLogout.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        },
        currentRouteTitle: function() {
            return this.$route.meta != null ? this.$route.meta.title : null;
        }

    },
    watch: {
        openConfirmationLogout(){}
    },
    beforeDestroy(){
        clearInterval(this.secondsLeft);
        clearTimeout(this.timeout);
    }
}
</script>

<style lang="scss" scoped>
img {
    width: 120px;
    height: 22px;
    max-height: 100%;
}

.fixed-bottom {
    .navbar-nav {
        padding-bottom: env(safe-area-inset-bottom);
    }
}

</style>